import { fetchAPI } from './base'

// where: {categoryNotIn: "645", parentNotIn: "645"}
export async function getAllPortfolioForHome(first = 10, after = '') {
  const portfolio = await fetchAPI(
    `query AllPosts($first: Int!, $after: String) {
      posts(first: $first, after: $after, where: { categoryName: "Portfolio", orderby: { field: DATE, order: DESC } }) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            databaseId
            title
            excerpt
            slug
            date
            featuredImage {
              node {
                sourceUrl
                srcSet
                sizes
              }
            }
            author {
              node {
                name
                firstName
                lastName
                description
                email
                avatar {
                  url
                  height
                  size
                  width
                  default 
                }
                mediaItems {
                  nodes {
                    sourceUrl
                    srcSet
                  }
                }
              }
            }
            tags {
              edges {
                node {
                  name
                  slug
                  uri
                }
              }
            }
            categories {
              edges {
                node {
                  name
                  slug
                }
              }
            }
          }
        }
      }
    }
  `,
    {
      variables: {
        first,
        after,
      },
    },
  )

  return portfolio?.posts
}

export async function getPostAndMorePosts(first = 10, after = '') {
  const portfoliomore = await fetchAPI(
    `query getPosts($first: Int!, $after: String) {
        posts(first: $first, after: $after, where: { categoryName: "Portfolio", orderby: { field: DATE, order: DESC } }) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              databaseId
              title
              excerpt
              slug
              date
              featuredImage {
                node {
                  sourceUrl
                  srcSet
                  sizes
                }
              }
              author {
                node {
                  name
                  firstName
                  lastName
                  description
                  email
                  avatar {
                    url
                    height
                    size
                    width
                    default
                  }
                  mediaItems {
                    nodes {
                      sourceUrl
                      srcSet
                    }
                  }
                }
              }
              tags {
                edges {
                  node {
                    name
                    slug
                    uri
                  }
                }
              }
              categories {
                edges {
                  node {
                    name
                    slug
                  }
                }
              }
            }
          }
        }
      }
    `,
    {
      variables: {
        first,
        after,
      },
    },
  )
  return portfoliomore?.posts
}

export async function getPostBySlug(slug: string) {
  const portfolioslug = await fetchAPI(
    `query PostBySlug($slug: ID!) {
      post(id: $slug, idType: SLUG ) {
        author {
          node {
            slug
            name
            firstName
            lastName
            description
            email
            avatar {
              url
              height
              size
              width
              default
            }
            mediaItems {
              nodes {
                sourceUrl
                srcSet
              }
            }
          }
        }
        id
        title
        featuredImage {
          node {
            sourceUrl
            srcSet
            sizes
          }
        }
        content(format: RENDERED)
        slug
        date
        tags {
          edges {
            node {
              name
              slug
            }
          }
        }
        categories {
          edges {
            node {
              name
              slug
            }
          }
        }
      }
    }`,
    {
      variables: {
        slug,
      },
    },
  )

  return portfolioslug?.post
}

export async function getPostNav(slug: string) {
  const portfolioNav = await fetchAPI(
    `query getPosts($slug: String!) {
        posts(
          after: $slug
          before: $slug
          last: 4
          where: { categoryName: "Portfolio", orderby: { field: DATE, order: DESC } }) {
        ) {
          pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
          }
          nodes {
            title
            uri
            slug
          }
        }
    `,
    {
      variables: {
        slug,
      },
    },
  )
  return portfolioNav?.posts
}

export async function getAllPostsWithSlug() {
  const portfolioAllPost = await fetchAPI(`
    {
      posts(first: 10000, where: { categoryName: "Portfolio", orderby: { field: DATE, order: DESC } }) {
        nodes {
          slug
          title
        }
      }
    }
  `)
  return portfolioAllPost?.posts
}

export async function getCategories() {
  const portfolioCate = await fetchAPI(`
    {
      categories {
        edges {
          node {
            name
            slug
          }
        }
      }
    }
  `)
  return portfolioCate?.categories
}

export async function getRelatedPost(cate: string, first = 3, after = '') {
  const related = await fetchAPI(
    `query RelatedPosts($first: Int!, $after: String, $cate: String) {
      posts(
        first: $first
        after: $after
        where: {categoryName: $cate}
      ) {
          pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            databaseId
            title
            excerpt
            slug
            date
            featuredImage {
              node {
                sourceUrl
                srcSet
                sizes
              }
            }
            author {
              node {
                name
                firstName
                lastName
                description
                email
                avatar {
                  url
                  height
                  size
                  width
                  default 
                }
                mediaItems {
                  nodes {
                    sourceUrl
                    srcSet
                  }
                }
              }
            }
            tags {
              edges {
                node {
                  name
                  slug
                  uri
                }
              }
            }
            categories {
              edges {
                node {
                  name
                  slug
                }
              }
            }
          }
        }
      }
    }`,
    {
      variables: {
        cate,
        first,
        after,
      },
    },
  )
  return related?.posts
}

export async function AllCategory() {
  const allCate = await fetchAPI(
    `query AllCategory {
      category(id: "portfolio", idType: SLUG) {
        id
        name
        slug
        taxonomyName
        children {
          nodes {
            id
            name
            slug
          }
        }
      }
    }`,
  )
  return allCate?.category
}

export async function AllByCategory(cate: string, first = 10, after = '') {
  const allbyCate = await fetchAPI(
    `query getPosts($first: Int!, $after: String, $cate: String) {
        posts(first: $first, after: $after, where: { categoryName: $cate, orderby: { field: DATE, order: DESC } }) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              databaseId
              title
              excerpt
              slug
              date
              featuredImage {
                node {
                  sourceUrl
                  srcSet
                  sizes
                }
              }
              author {
                node {
                  name
                  firstName
                  lastName
                  description
                  email
                  avatar {
                    url
                    height
                    size
                    width
                    default
                  }
                  mediaItems {
                    nodes {
                      sourceUrl
                      srcSet
                    }
                  }
                }
              }
              tags {
                edges {
                  node {
                    name
                    slug
                    uri
                  }
                }
              }
              categories {
                edges {
                  node {
                    name
                    slug
                  }
                }
              }
            }
          }
        }
      }
    `,
    {
      variables: {
        cate,
        first,
        after,
      },
    },
  )
  return allbyCate?.posts
}

export async function AllTags() {
  const allTag = await fetchAPI(`
    query AllTags {
      terms(where: {taxonomies: TAG}) {
        edges {
          node {
            name
            slug
            id
            count
          }
        }
      }
    }
  `)
  return allTag?.terms
}
